import axios, { type AxiosInstance, type AxiosError } from 'axios'
import router from '@/router'

// Create axios instance
const apiClient: AxiosInstance = axios.create({
  baseURL: '/api',
  withCredentials: true, // Important for cookies
  headers: {
    'Content-Type': 'application/json'
  }
})

// Response interceptor for error handling
apiClient.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    if (error.response?.status === 401) {
      // Redirect to login on auth error
      router.push('/login')
    }
    return Promise.reject(error)
  }
)

export default apiClient
